import { render, staticRenderFns } from "./CalendarForm.vue?vue&type=template&id=01837a8a&scoped=true&"
import script from "./CalendarForm.vue?vue&type=script&lang=js&"
export * from "./CalendarForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarForm.vue?vue&type=style&index=0&id=01837a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01837a8a",
  null
  
)

export default component.exports